import { Action, createReducer, on } from '@ngrx/store';
import { IMerkmalState } from './merkmal.state';
import * as MerkmalActions from './merkmal.actions';

export const initialState: IMerkmalState = {
  lastSelectedMerkmal: null,
  merkmaleTree: [],
};

const merkmalReducerInternal = createReducer(
  initialState,
  
  on(MerkmalActions.setSelectedMerkmal, (state, { lastSelectedMerkmal }) => ({
    ...state,
    lastSelectedMerkmal,
  })),
  
  on(MerkmalActions.loadMerkmale, (state) => ({
    ...state,
  })),
  
  on(MerkmalActions.loadMerkmaleSuccess, (state, { merkmale }) => ({
    ...state,
    merkmaleTree: merkmale,
  })),
);

export function merkmalReducer(state: IMerkmalState | undefined, action: Action): IMerkmalState {
  return merkmalReducerInternal(state, action);
}
